export const maxPrice = 1200

export const filterSearchToAPISearch = (filterSearch) => {
  const apiSearch = {
    grain: [],
    // storageType,
    // offerType, 
    // state, 
    // region
  }

  // Grains & grades
  Object.keys(filterSearch.grain).forEach(key => {
    if (filterSearch.grain[key]) {
      const grades = filterSearch.grades[key].map(item => {return {name: item}})
      apiSearch.grain.push({name: key, grades: grades})
    }
  })

  // Storage type
  const storageTypes = Object.keys(filterSearch.storageType).filter(item => filterSearch.storageType[item])
  if (storageTypes.length === 1) {
    apiSearch.storageType = storageTypes[0]
  }

  // Offer type
  const offerTypes = Object.keys(filterSearch.offerType).filter(item => filterSearch.offerType[item])
  if (offerTypes.length === 1) {
    apiSearch.offerType = offerTypes[0]
  }

  // TODO: state & region

  // Location
  const location = filterSearch.address?.[0]
  if (location) {
    console.log('filterSearchToAPISearch location', location)
    apiSearch.state = location.state
    apiSearch.location = location.formattedAddress
    if (apiSearch.city) {
      apiSearch.latitude = location.latitude
      apiSearch.longitude = location.longitude
      apiSearch.searchRadius = 250
    }
  }

  // Price max
  if (filterSearch.priceMax && filterSearch.priceMax !== maxPrice) {
    apiSearch.priceMax = filterSearch.priceMax
  }

  return apiSearch
}

export const apiSearchToFilterSearch = (input) => {
  const apiSearch = JSON.parse(JSON.stringify(input))

  const filterSearch = {
    grain: {},
    grades: {},
    storageType: {},
    offerType: {},
    address: [],
    priceMax: maxPrice
  }

  try {
    // Handle special case for Wanted class where grain and grade are flat strings
    if (typeof input.grain === 'string' && input.grain.length > 0) {
      apiSearch.grain = [{name: input.grain, grades: []}]
      if (typeof input.grade === 'string' && input.grade.length > 0) {
        apiSearch.grain[0].grades.push({name: input.grade})
      }
    }

    // Grain & grades
    if (Array.isArray(apiSearch.grain)) {
      apiSearch.grain.forEach(grain => {
        filterSearch.grain[grain.name] = true
        if (Array.isArray(grain.grades)) {
          filterSearch.grades[grain.name] = grain.grades.map(grade => grade.name)
        }
      })
    }

    // Storage type
    if (apiSearch.storageType) {
      filterSearch.storageType[apiSearch.storageType] = true
    }

    // Offer type
    if (apiSearch.offerType) {
      filterSearch.offerType[apiSearch.offerType] = true
    }

    // TODO: state & region

    // Location
    if (apiSearch.location) {
      filterSearch.address = [{ 
        state: apiSearch.state,
        formattedAddress: apiSearch.location,
        latitude: apiSearch.latitude,
        longitude: apiSearch.longitude
      }]
    }
    
    // Price max
    if (apiSearch.priceMax) {
      filterSearch.priceMax = apiSearch.priceMax
    }
  } catch (e) {
    console.error(e)
  }

  console.log('apiSearchToFilterSearch', apiSearch, filterSearch)
  return filterSearch
}

/*
[{"name":"WHEAT","grades":[{"name":"ANW1_CSG120_WHEAT"}]},{"name":"BARLEY","grades":[{"name":"BAR3_BARLEY"},{"name":"BAW_BARLEY"}]}]

{
"grain": {
  "WHEAT": true
},
"grades": {
  "WHEAT": [
      "AH14_WHEAT"
  ]
},
"storageType": {
  "WAREHOUSE": true
},
"address": [
  {
      "state": "NSW",
      "postCode": "2000",
      "city": "Millers Point",
      "streetAddress": "",
      "formattedAddress": "Millers Point NSW",
      "latitude": -33.8583029,
      "longitude": 151.203538
  }
]
}
*/